<template>
    <div class="pl10 mt20" style="word-break: break-all;">
        <div class="pr10 mb10" align="right" v-if="control.loginType == 1 && basicForm.hasSearch == 1" >
            <el-button type="primary" @click="editContactfoData">修改联系人信息</el-button>
        </div>

        <div class="pr10 mb10" v-if="basicForm.hasSearch == 0">您无权限查看此供应商联系人信息</div>

        <span class="dib" v-if="basicForm.hasSearch == 1">业务联系人信息</span><span class="line" v-if="basicForm.hasSearch == 1"></span>
        <div class="mt20" v-if="basicForm.hasSearch == 1">
            <el-form :model="basicForm" label-width="207px" class="demo-ruleForm">
                <!-- 业务联系人姓名 -->
                <el-form-item class="mt20" label="联系人姓名:">
                    <span>{{ basicForm.contactName }}</span>
                </el-form-item>

                <!-- 业务联系人手机号 -->
                <el-form-item label="联系人手机号:">
                    <span>{{ basicForm.contactMobile }}</span>
                </el-form-item>

                <!-- 业务联系人座机 -->
                <el-form-item label="联系人座机:" v-if="basicForm.contactLandline">
                    <span>{{ basicForm.contactLandline }}</span>
                </el-form-item>

                <!-- 业务联系人邮箱 -->
                <el-form-item label="联系人邮箱:">
                    <span>{{ basicForm.contactEmail }}</span>
                </el-form-item>

                <!-- 业务联系人QQ -->
                <el-form-item label="联系人QQ:">
                    <span>{{ basicForm.contactQQ }}</span>
                </el-form-item>

                <!-- 业务职务 -->
                <el-form-item label="职务:" v-if="basicForm.contactPosition">
                    <span>{{ basicForm.contactPosition }}</span>
                </el-form-item>

                <span class="dib">合同联系人信息</span><span class="line"></span>
                <!-- 业务联系人姓名 -->
                <el-form-item class="mt20" label="联系人姓名:">
                    <span>{{ basicForm.contractContactName }}</span>
                </el-form-item>

                <!-- 业务联系人手机号 -->
                <el-form-item label="联系人手机号:">
                    <span>{{ basicForm.contractContactMobile }}</span>
                </el-form-item>

                <!-- 业务联系人座机 -->
                <el-form-item label="联系人座机:" v-if="basicForm.contractContactLandline">
                    <span>{{ basicForm.contractContactLandline }}</span>
                </el-form-item>

                <!-- 业务联系人邮箱 -->
                <el-form-item label="联系人邮箱:">
                    <span>{{ basicForm.contractContactEmail }}</span>
                </el-form-item>

                <!-- 业务联系人QQ -->
                <el-form-item label="联系人QQ:">
                    <span>{{ basicForm.contractContactQQ }}</span>
                </el-form-item>

                <!-- 业务职务 -->
                <el-form-item label="职务:" v-if="basicForm.contractContactPosition">
                    <span>{{ basicForm.contractContactPosition }}</span>
                </el-form-item>

                <span class="dib">客服联系人信息</span><span class="line"></span>
                <!-- 业务联系人姓名 -->
                <el-form-item class="mt20" label="联系人姓名:">
                    <span>{{ basicForm.customServiceContactName }}</span>
                </el-form-item>

                <!-- 业务联系人手机号 -->
                <el-form-item label="联系人手机号:">
                    <span>{{ basicForm.customServiceContactMobile }}</span>
                </el-form-item>

                <!-- 业务联系人座机 -->
                <el-form-item label="联系人座机:" v-if="basicForm.customServiceContactLandline">
                    <span>{{ basicForm.customServiceContactLandline }}</span>
                </el-form-item>

                <!-- 业务联系人邮箱 -->
                <el-form-item label="联系人邮箱:">
                    <span>{{ basicForm.customServiceContactEmail }}</span>
                </el-form-item>

                <!-- 业务联系人QQ -->
                <el-form-item label="联系人QQ:">
                    <span>{{ basicForm.customServiceContactQQ }}</span>
                </el-form-item>

                <!-- 业务职务 -->
                <el-form-item label="职务:" v-if="basicForm.customServiceContactPosition">
                    <span>{{ basicForm.customServiceContactPosition }}</span>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script type="text/javascript">
    export default {
        data () {
            return {
                suppliersId: 0,
                // 预览图片
                dialogImageUrl: '',
                dialogVisible: false,
                // 提交数据
                basicForm: {hasSearch:0},

                records:[],

                control:{
                    loginType:0,
                    status:0,
                    view:0,
                    audit:0
                }
            }
        },
        methods: {
            // 初始化
            initBasicInfo(suppliersId){
                var that = this;
                $.get({
                    url: '/suppliers/supplier/contact/find',
                    data: {
                        suppliersId: suppliersId
                    },
                    success: function (result) {
                        if (!result.code) {
                            that.basicForm = result.data;
                            that.suppliersId = result.data.suppliersId;
                        } else if(result.code == 10067) {
                            window.location.href = "/suppliers/index";
                        } else {
                            that.$message({
                                showClose: true,
                                message: result.msg,
                                type: 'error'
                            });
                        }
                    }
                })
            },

            //
            initControl(suppliersId){
                var that = this;
                $.get({
                    url: '/suppliers/supplier/control',
                    data: {
                        suppliersId: suppliersId,
                        type:1
                    },
                    success: function(result) {
                        if (!result.code) {
                            that.control = result.data;
                        } else {
                            that.$message({
                                showClose: true,
                                message: result.msg,
                                type: 'error'
                            });
                        }
                    }
                })
            },

            // 编辑联系人
            editContactfoData() {
                var that = this;
                this.$router.push({
                    path:'/supplier_contact_manage?suppliersId=' + that.suppliersId
                })
            },
        },

        mounted () {
            var suppliersId = this.$route.query.suppliersId;
            this.suppliersId = suppliersId;
            this.initBasicInfo(suppliersId);
            this.initControl(suppliersId);
        }
    }
</script>

<style type="text/css" lang="less" scoped>
    .line {
            display: inline-block;
            margin-left: 3%;
            width: 80%;
            height: 1px;
            border-bottom: 1px dashed #999;
            vertical-align: middle;
        }

        .second_line {
            display: inline-block;
            margin-left: 3%;
            width: 87%;
            height: 1px;
            border-bottom: 1px dashed #666;
            vertical-align: middle;
        }

        .word_num {
            display: inline-block;
            margin-bottom: 22px;
            margin-left: 5px;
            color: #666;
            vertical-align: bottom;
        }

        .pic_tip {
            position: absolute;
            top: 100%;
            left: 0;
            padding-top: 4px;
            color: #ff4949;
            font-size: 12px;
            line-height: 1px;
        }

        .pic_skan {
            box-sizing: border-box;
            margin-top: 5px;
            width: 150px;
            height: 150px;
            border: 1px solid #c0ccda;
            border-radius: 6px;
            cursor: pointer;
        }

        .pic_min_skan {
            box-sizing: border-box;
            margin-top: 5px;
            width: 60px;
            height: 60px;
            border: 1px solid #c0ccda;
            border-radius: 6px;
            cursor: pointer;
        }

        .form_color {
            color: rgb(106, 72, 77);
        }

        .el-form-item {
            margin-bottom: 0;
        }
</style>


// WEBPACK FOOTER //
// contactInfo.vue?b93fe91e